import { render } from "./ViewChallengeFlow.vue?vue&type=template&id=b816510e&scoped=true"
import script from "./ViewChallengeFlow.vue?vue&type=script&lang=js"
export * from "./ViewChallengeFlow.vue?vue&type=script&lang=js"

import "@/css/views/view-challenge-flow.css?vue&type=style&index=0&id=b816510e&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b816510e"]])

export default __exports__